module.exports = __webpack_public_path__ + "static/media/staffing2.1d813401.jpg";